import React from 'react';
import { Link, useLoaderData } from 'react-router-dom';
import customFetch from '../../../utils/customFetch';
import { useQuery } from '@tanstack/react-query';
import CardVorschau from '../../bestellungen/CardVorschau';

const cardsQuery = {
  queryKey: ['cards'],
  queryFn: async () => {
    const data = await customFetch.get('/cards/showAllMyCards');
    return data;
  },
};

export const loader = (queryClient) => async () => {
  const { data } = await queryClient.ensureQueryData(cardsQuery);
  return { data };
};

const CardList = () => {
  const { data } = useQuery(cardsQuery).data;
  console.log(data);
  return (
    <ul
      role="list"
      className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8"
    >
      {data.userCards.map((card) => (
        <li key={card._id} className="relative">
          <div className="group aspect-[1.586/1] block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-svisit-primary-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100">
            <div className="pointer-events-none object-cover group-hover:opacity-75">
              <CardVorschau bildInfos={card.graphicFront} />
            </div>

            <button
              type="button"
              className="absolute inset-0 focus:outline-hidden"
            >
              <span className="sr-only">Details ansehen zu {card.name}</span>
            </button>
          </div>
          <p className="pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900">
            Hinzugefügt am {card.createdAt.split('T')[0]}
          </p>
        </li>
      ))}
      <li className="relative aspect-[1.586/1]">
        <button
          type="button"
          className="relative block w-full h-full rounded-lg border-2 border-dashed border-gray-300 p-3 text-center hover:border-gray-400 focus:outline-hidden focus:ring-2 focus:ring-svisit-primary-500 focus:ring-offset-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1}
            stroke="currentColor"
            className="mx-auto h-12 w-12 text-gray-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"
            />
          </svg>

          <Link to="/produkte">
            <span className="mt-2 block text-sm font-semibold text-gray-900">
              Neue Karte hinzufügen
            </span>
          </Link>
        </button>
      </li>
    </ul>
  );
};

export default CardList;
